module.exports = __webpack_public_path__ + "img/herb-encrusted-chicken-breast-with-mango-chutney.c2739077.jpg";